<template>
  <div class="articleWrapper md-layout">
    <md-field class="md-layout-item md-size-100">
      <label>Fb link</label>
      <md-input v-model="fb"></md-input>
    </md-field>
    <md-field class="md-layout-item md-size-100">
      <label>Insta link</label>
      <md-input v-model="insta"></md-input>
    </md-field>
    <div class="md-layout-item md-size-100">
      <input type="file" @change="processFile($event)" />
      <img :src="imageUrl" class="preview" />
    </div>
    <md-button
      @click="onUpdateMyData()"
      class="md-layout-item md-size-20 md-raised md-primary"
    >Update</md-button>
    <div class="bigTitle md-layout-item md-size-100">Description</div>
    <vue-editor class="vueEditorFixHeight md-layout-item md-size-100" v-model="contentDesc"></vue-editor>
    <div class="bigTitle md-layout-item md-size-100">Content</div>
    <vue-editor class="vueEditorFixHeight md-layout-item md-size-100" v-model="content"></vue-editor>
  </div>
</template>

<script>
// @ is an alias to /src
import { VueEditor } from "vue2-editor";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "meEditor",
  components: {
    VueEditor
  },
  mounted() {
    this.content = this.getMyDataContent.content;
    this.fb = this.getMyDataContent.fb;
    this.insta = this.getMyDataContent.insta;
    this.contentDesc = this.getMyDataContent.desc;
    this.imageUrl = this.getMyDataContent.url;
  },
  data() {
    return {
      content: "",
      fb: "",
      insta: "",
      contentDesc: "",
      imageUrl: ""
    };
  },
  methods: {
    ...mapActions(["updateMyData", "uploadImage"]),
    onUpdateMyData() {
      this.updateMyData({
        content: this.content,
        insta: this.insta,
        fb: this.fb,
        contentDesc: this.contentDesc,
        url: this.imageUrl
      });
    },
    async processFile(event) {
      var file = event.target.files[0];
      const { url } = await this.uploadImage(file);
      this.imageUrl = url;
    }
  },
  computed: {
    ...mapGetters(["getMyDataContent"])
  }
};
</script>

<style >
#mapid2 {
  height: 500px;
}
.addBtn {
  background-color: white;
  color: black;
  height: 50px;
  margin: 10px;
}
.addBtn:hover {
  cursor: pointer;
}

.articleWrapper {
  background-color: white;
  color: black;
}
</style>
